export default "__VITE_ASSET__DRSMmEBZ__"